import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

class Dropdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      isDisabled: this.props.isDisabled,
    }

    this.triggerDropdown = this.triggerDropdown.bind(this)
    this.setContentRef = this.setContentRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isDisabled: nextProps.isDisabled })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  setContentRef(node) {
    this.contentRef = node
  }

  handleClickOutside(e) {
    if (this.contentRef && !this.contentRef.contains(e.target) && this.state.isOpen) {
      this.setState({ isOpen: false })
    }
  }

  triggerDropdown() {
    if (!this.state.isDisabled) {
      this.setState({ isOpen: !this.state.isOpen })
    }
  }

  getDropdownHeader(title) {
    const iconType = this.state.isOpen && !this.state.isDisabled ? 'caret-up' : 'caret-down'

    return (
      <div className="custom-dropdown__header" onClick={this.triggerDropdown}>
        <div className="custom-dropdown__title">
          {this.props.titleIcon && <Icon type={this.props.titleIcon} className="title-icon" />}
          <span className="dropdown-title">{title}</span>
        </div>
        <div className="custom-dropdown__caret">
          <Icon type={['fas', iconType]} color="grey-dark" notSpaced />
        </div>
      </div>
    )
  }

  render() {
    const dropdownDisabled = this.state.isDisabled ? 'is-disabled' : ''
    const contentStatus = !this.state.isOpen || this.state.isDisabled ? 'is-hidden' : ''

    return (
      <div className={`custom-dropdown ${dropdownDisabled} ${this.props.className}`}>
        {this.getDropdownHeader(this.props.title)}

        <div className={`custom-dropdown__content ${contentStatus}`} ref={this.setContentRef}>
          {this.getDropdownHeader(this.props.title)}

          <div className="custom-dropdown__dropdown">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  titleIcon: PropTypes.arrayOf(PropTypes.string),
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
}

Dropdown.defaultProps = {
  isDisabled: false,
  titleIcon: null,
  className: '',
}

export default Dropdown
